export const quotes = {
	createAdventure: [
		{
			text: 'Avoiding danger is no safer in the long run than outright exposure. Life is either a daring adventure or nothing.',
			source: 'Helen Keller'
		},
		{
			text: 'Adventure is worthwhile in itself.',
			source: 'Amelia Earhart'
		},
		{
			text: 'If we were meant to stay in one place, we’d have roots instead of feet.',
			source: 'Rachel Wolchin'
		},
		{
			text: 'The danger of adventure is worth a thousand days of ease and comfort.',
			source: 'Paulo Coelho'
		},
	],
	updateUser: [
		{
			text: 'Things change. And friends leave. Life doesn\'t stop for anybody.',
			source: ''
		},
		{
			text: 'Everyone thinks of changing the world, but no one thinks of changing himself.',
			source: ''
		},
		{
			text: 'Yesterday I was clever, so I wanted to change the world. Today I am wise, so I am changing myself.',
			source: ''
		},
		{
			text: 'They always say time changes things, but you actually have to change them yourself.',
			source: ''
		},
	],
	searchLocation: [
		{
			text: 'Not all those who wander are lost.',
			source: 'J.R.R. Tolkien, The Fellowship of the Ring',
		}
	],
	explore: [
		{
			text: 'The world is a book, and those who do not travel read only one page.',
			source: 'Augustine of Hippo',
		},
		{
			text: 'Once a year, go someplace you’ve never been before.',
			source: 'Dalai Lama',
		},
		{
			text: 'Not all those who wander are lost.',
			source: 'J.R.R. Tolkien',
		},
		{
			text: 'Adventure is worthwhile in itself.',
			source: 'Amelia Earhart',
		},
		{
			text: 'Travel far enough, you meet yourself.',
			source: 'David Mitchell',
		},
		{
			text: 'To move, to breathe, to fly, to float — to gain all while you give.',
			source: 'Hans Christian Andersen',
		},
	]
}
